import { useEffect, useState, useRef } from "react";
import { ArrowsContainer, ArrowButton } from "./localStyle";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";

/*
  Componente: ScrollArrows
  Descripción: Muestra dos flechas para scrollear verticalmente un contenedor objetivo.
  - targetRef: referencia al contenedor que debe scrollear.
  - stepPx: cantidad de pixeles por paso.
  - holdIntervalMs: intervalo de scroll continuo mientras se mantiene presionado.
  - showThresholdPx: umbral mínimo de altura (scrollHeight - clientHeight) para mostrar.
*/
const ScrollArrows = ({
  targetRef,
  stepPx = 64,
  holdIntervalMs = 100,
  showThresholdPx = 48,
}) => {
  const [visible, setVisible] = useState(false);
  const holdTimer = useRef(null);

  useEffect(() => {
    const el = targetRef?.current;
    if (!el) return;

    const updateVisibility = () => {
      const canScroll = el.scrollHeight - el.clientHeight > showThresholdPx;
      setVisible(canScroll);
    };
    updateVisibility();
    el.addEventListener("scroll", updateVisibility);
    const ro = new ResizeObserver(updateVisibility);
    ro.observe(el);

    return () => {
      el.removeEventListener("scroll", updateVisibility);
      ro.disconnect();
    };
  }, [targetRef, showThresholdPx]);

  const scrollOnce = (direction) => {
    const el = targetRef?.current;
    if (!el) return;
    el.scrollTo({
      top: el.scrollTop + (direction === "up" ? -stepPx : stepPx),
      behavior: "smooth",
    });
  };

  const startHold = (direction) => {
    if (holdTimer.current) clearInterval(holdTimer.current);
    holdTimer.current = setInterval(
      () => scrollOnce(direction),
      holdIntervalMs
    );
  };
  const stopHold = () => {
    if (holdTimer.current) {
      clearInterval(holdTimer.current);
      holdTimer.current = null;
    }
  };

  if (!visible) return null;

  return (
    <ArrowsContainer>
      <ArrowButton
        aria-label="Desplazar hacia arriba"
        onClick={() => scrollOnce("up")}
        onMouseDown={() => startHold("up")}
        onMouseUp={stopHold}
        onMouseLeave={stopHold}
      >
        <FaChevronUp />
      </ArrowButton>
      <ArrowButton
        aria-label="Desplazar hacia abajo"
        onClick={() => scrollOnce("down")}
        onMouseDown={() => startHold("down")}
        onMouseUp={stopHold}
        onMouseLeave={stopHold}
      >
        <FaChevronDown />
      </ArrowButton>
    </ArrowsContainer>
  );
};

export default ScrollArrows;
